import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import clsx from "clsx";
import { ChevronRight } from "@mui/icons-material";
import useMediaQuery from "../../../base/useMediaQuery";

/**
 * @author Sarthak Sharma.
 * @since 27-12-2023.
 * @description Side Form component.
 */

const SideForm = (props) => {
  const { open, onClose, children } = props;

  const isDeskTop = useMediaQuery("(min-width: 1100px)");
  const [absolute, setAbsolute] = useState(true);

  useEffect(() => {
    if (!open) setTimeout(setAbsolute?.bind(null, true), 500);
    else setAbsolute(false);
  }, [open]);

  return (
    <>
      {!isDeskTop && open && (
        <div
          onClick={onClose}
          className="fixed top-0 left-0 z-[2] h-screen bg-[#3b3b3b5b] w-[100%]"
        ></div>
      )}
      {open && (
        <div className="w-0 overflow-visible h-full">
          <div
            onClick={onClose}
            className={clsx(
              "bg-white rounded-l-[5px] w-10 h-10 shadow-[-4px_0_3px_#E8E8E9] select-none flex items-center active:bg-[#E8E8E9] cursor-pointer absolute mt-0 z-[3]",
              {
                "-ml-[40px]": isDeskTop,
                "-ml-[410px]": !isDeskTop,
              }
            )}
          >
            <ChevronRight className="ml-2" />
          </div>
        </div>
      )}
      <Box
        className={clsx(
          "max-w-[450px] transition-transform duration-500 bg-white overflow-x-hidden w-full",
          {
            "translate-x-0": open,
            "translate-x-full": !open,
            absolute: absolute,
            "shadow-[-4px_0_3px_#E8E8E9]": isDeskTop,
            "fixed right-0 z-[3] h-[85%]": !isDeskTop,
          }
        )}
      >
        {/* <div className="mb-4">
                    <div onClick={onClose} className="bg-white rounded-r-[5px] w-10 h-10 shadow-[4px_1px_3px_#E8E8E9] select-none flex items-center active:bg-[#E8E8E9] cursor-pointer absolute top-0 -left-1">
                        <ChevronLeft className="ml-2" />
                    </div>
                </div> */}
        {children}
      </Box>
    </>
  );
};

export default React.memo(SideForm, (prevProps, nextProps) => {
  return (
    prevProps.open === nextProps.open &&
    prevProps.children === nextProps.children
  );
});
